
//     Init Variant Selects
//
//     Data attributes accept:
//     - data-disable-url-update: {bool} Disable url update on variant change (optional)
//
//     Usage:
//     <variant-selects data-section="{{ product.id }}" data-url="{{ product.url }}" data-disable-url-update></variant-selects>

class VariantSelects extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // string
        this.sectionId = this.dataset.section;
        this.productUrl = this.dataset.url;
        this.disableUrlUpdate = this.hasAttribute('data-disable-url-update') || false;
        this.isLook = true;
        this.options = {};
        this.currentVariant = {};
        this.sectionToUpdate = this.dataset.sectionToUpdate;

        // DOM
        this.productForm = document.getElementById(`product-form-${this.sectionId}`);
        if (this.productForm == null) { return; }

        this.price = document.getElementById(`price-${this.sectionId}`);
        this.addButton = this.productForm.querySelector('[name="add"]');
        this.addButtonText = this.addButton.querySelector('span');

        this.updateOptions();
        this.updateCurrentVariant();
        this.addEventListener('change', this.debounce(() => {
            this.onVariantChange();
        }, 200));
    }

    onVariantChange() {
        this.updateOptions();
        this.updateCurrentVariant();
        // this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            // this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }

        this.dispatchEvent(new Event('onvariantchange', { bubbles: true }));
    }

    debounce(callback, delay){
        var timer;
        return function(){
            var args = arguments;
            var context = this;
            clearTimeout(timer);
            timer = setTimeout(function(){
                callback.apply(context, args);
            }, delay)
        }
    }

    // when a product variant is selected, DOM element needs to be update
    // register here every section to update and don't forget to match their id
    getSectionsToUpdate() {
        return [
            `price-${this.sectionId}`,
            `product-tags-${this.sectionId}`,
            `product-delivery-${this.sectionId}`,
            `product-addtocart-${this.sectionId}`,
            `product-gift-card-radios-${this.sectionId}`,
            `product-low-stock-${this.sectionId}`
        ]
    }

    getProductInfoUrl() {
        return `${this.productUrl}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateCurrentVariant() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGallery = document.getElementById(`MediaGallery-${this.sectionId}`);
        mediaGallery?.setActiveMedia(`${this.sectionId}-${this.currentVariant.featured_media.id}`, true);

        const modalContent = document.querySelector(`#ProductModal-${this.sectionId} .product-media-modal__content`);
        const newMediaModal = modalContent?.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent?.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.disableUrlUpdate) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.sectionId}`);
        for (let i = 0; i < productForms.length; i++) {
            const input = productForms[i].querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const url = this.getProductInfoUrl();
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const sectionsToUpdate = this.getSectionsToUpdate();

                for (let i = 0; i < sectionsToUpdate.length; i++) {
                    const oldSections = document.querySelectorAll(`#${sectionsToUpdate[i]}`)
                    for (let j = 0; j < oldSections.length; j++) {
                        const new_section = html.getElementById(sectionsToUpdate[i]);
                        if (oldSections[j] && new_section && !oldSections[j].isEqualNode(new_section)) oldSections[j].innerHTML = new_section.innerHTML;
                    }
                }
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        if (!this.productForm) return;

        // @todo fetch content in case string is different then variantStrings.unavailable
        if (disable) {
            this.addButton.setAttribute('disabled', 'disabled');
            if (text) this.addButtonText.textContent = window.variantStrings.stockAlert;
        } else {
            this.addButton.removeAttribute('disabled');
            if (text) this.addButtonText.textContent = text;
            else this.addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        if (!this.addButton) return;
        // @todo fetch content in case string is different then variantStrings.unavailable
        this.addButton.textContent = window.variantStrings.unavailable;
        if (this.price) this.price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
  }
  
customElements.define('variant-radios', VariantRadios);

class VariantSelectsCrossSell extends VariantSelects {
    constructor() {
        super();
    }

    updateMedia() {
        return;
    }

    getProductInfoUrl() {
        return `${this.productUrl}?variant=${this.currentVariant.id}&view=crosssell-card`;
    }

    getSectionsToUpdate() {
        return [
            `product-addtocart-${this.sectionId}`
        ]
    }

    updateURL() {
        return;
    }
}

if (customElements.get('variant-selects-crosssell') === undefined) {
    customElements.define('variant-selects-crosssell', VariantSelectsCrossSell);
}

